const IMAGE_COUNT = 9
const VIDEO_COUNT = 9

const YOUTUBE_URL = 'https://www.youtube.com/watch?v=Y-x0efG1seA'

export interface GalleryVideo {
  thumbnail: string
  url: string
}

export const galleryImages: string[] = Array.from(
  { length: IMAGE_COUNT },
  (_, index) => `/assets/images/gallery/gallery-${index + 1}.jpg`,
)

export const galleryVideos: GalleryVideo[] = Array.from({ length: VIDEO_COUNT }, (_, index) => ({
  thumbnail: `/assets/images/video-gallery/video-gallery-${index + 1}.jpg`,
  url: YOUTUBE_URL,
}))
